import { formatNumberDisplayValue, maxDecimalValue } from '@/utils/numberUtil';
import { Translations } from '@/utils/translations/Translations';
export const frenchTranslations: Translations = {
  admin: {
    applicationCyclesCurrent: 'Cycles de candidature actuels',
    applicationCyclesHeader: 'Cycles de candidature',
    applicationCyclesPast: 'Cycles de candidature passés',
    applicationCyclesUpcoming: 'Cycles de candidature à venir',
    applicationsHeader: 'Candidatures',
    emailsHeader: 'E-mails',
    tabEmailActivity: 'Activité e-mail',
    tabSendEmail: 'Envoyer un e-mail',
    tabTcowMassApproval: 'Approbation de masse TCOW',
  },
  address: {
    addAddress2: '+ App./Suite/Unité',
    labelCity: 'Ville',
    labelCountry: 'Pays',
    labelCounty: 'Comté',
    labelState: 'État',
    labelStreetAddress: 'Adresse',
    labelStreetAddress2: 'App./Suite/Unité',
    labelZipCode: 'Code Postal',
  },
  applicationHeader: {
    headerViewingApplication: "Affichage de l'application pour",
    messageRequiredQuestions: 'Veuillez remplir toutes les questions obligatoires',
    missingRequiredQuestions: 'Questions obligatoires manquantes',
    reviewerComments: 'Commentaires du Réviseur',
    standardCompleted: 'Concluído',
    starAwarded: 'Étoile décernée',
    yearsRecognized: (year: number) => `Candidature pour l’année ${year} de reconnaissance`,
  },
  applicationPreview: {
    backToAdmin: 'Retour à Admin',
    previewModeMessage:
      'Le mode aperçu est activé. Les modifications dans cette vue ne sont pas enregistrées.',
    programLabel: 'Programme',
    unknownValue: 'Inconnu',
  },
  applicationBody: {
    approveApplicationButton: 'Approuver la demande',
    resubmitButton: 'Renvoyer',
    sendBackToApplicantWithComments: 'Renvoyer la demande au demandeur avec des commentaires',
    starApprovalButton: 'Approuver l’étoile',
    starRemovalButton: 'Retirer l’étoile',
    submitButton: 'Envoyer',
    submitMessage: 'Envoi en cours...',
    tooltipApproveSendsToNextReviewStage:
      'Cliquer sur « Approuver » envoie la demande à l’étape de révision suivante.',
    tooltipApproveBeforeSubmit:
      'Veuillez vous assurer que votre révision est terminée avant de cliquer sur « Approuver ».',
    tooltipApproveWithUnresolvedComments:
      'Veuillez résoudre tous les commentaires avant d’approuver la demande. Les commentaires non résolus se trouvent dans les normes en jaune dans la barre de progression.',
    tooltipNextStandard: 'Norme Suivante',
    tooltipPreviousStandard: 'Norme précédente',
    tooltipRequiredQuestions: "Veuillez d'abord répondre à toutes les questions obligatoires",
    tooltipSendBackRequiresComment:
      'Veuillez saisir un commentaire pour cette étape de révision avant de renvoyer la demande au demandeur.',
  },
  common: {
    ariaSaved: 'Enregistré',
    ariaSaveFailed: "Échec de l'enregistrement",
    ariaSaving: 'Enregistrement',
    buttonPost: 'Publier',
    buttonReactivate: 'Réactiver',
    buttonResolve: 'Résoudre',
    defaultConfirmationModalText: {
      header: "Confirmer l'action",
      confirmationMessage: 'Êtes-vous sûr de vouloir effectuer cette action ?',
      cancelButtonText: 'Annuler',
      confirmationButtonText: 'Confirmer',
      successMessage: 'Suppression effectuée avec succès !',
    },
    error: 'Erreur',
    buttonSave: 'Enregistrer',
    buttonSaving: 'Enregistrement...',
    buttonDelete: 'Supprimer',
    buttonUpdate: 'Mettre à jour',
    characterCountRemaining: (remaining: number, max: number) =>
      `${remaining}/${max} caractères restants`,
    commentResolved: 'Commentaire résolu',
    genericError: 'Une erreur s’est produite. Veuillez réessayer.',
    messageCommentAddedSuccessfully: 'Commentaire ajouté avec succès !',
    messageCommentAddFailed: "Échec de l'ajout du commentaire",
    messageCommentCannotBeEmpty: 'Le commentaire ne peut pas être vide !',
    messageCommentTooLong: 'Le commentaire est trop long !',
    messageGrowthAwardApprovalSuccess: 'Approbation réussie !',
    messageGrowthAwardApproveProblem:
      "Un problème est survenu lors de l'approbation du prix de croissance. Veuillez réessayer plus tard.",
    messageGrowthAwardApproving: 'Approbation du prix de croissance ...',
    messageGrowthAwardCategoriesFetchError:
      'Erreur lors du chargement des catégories du prix de croissance.',
    messageGrowthAwardCommentRequired:
      'Veuillez saisir un commentaire avant de renvoyer la demande au demandeur.',
    messageGrowthAwardReturnSuccess: 'Retour réussi !',
    messageGrowthAwardSendBackProblem: 'Un problème est survenu lors du renvoi de la demande.',
    messageGrowthAwardSendingBack: 'Renvoi du prix de croissance au demandeur...',
    messageGrowthAwardSubmitted: 'Demande de prix de croissance soumise !',
    messageGrowthAwardSubmitting: 'Soumission du prix de croissance ...',
    messageGrowthAwardSubmitProblem:
      'Un problème est survenu lors de la soumission du prix de croissance.',
    noMatch: 'Aucun résultat trouvé.',
    placeholderPostComment: 'Publier un commentaire',
    previewInputPlaceholder: "Saisie d'aperçu (non enregistrée)",
    previewWorkflowSpecificDataNotice:
      "Cette question utilise des données spécifiques au workflow en production. Le mode aperçu capture uniquement le texte local et n'appelle pas les API.",
    buttonContinue: 'Continuer',
    buttonCancel: 'Annuler',
    buttonClose: 'Fermer',
    requiredIndicatorTitle: 'obligatoire',
    statusApplicationApproved: 'Demande approuvée',
    statusApplicationReturned: 'Demande renvoyée',
    statusApplicationSubmitted: 'Demande soumise',
    statusApproving: 'Approbation...',
    statusReturning: 'Retour en cours...',
    statusUpdating: 'Mise à jour ...',
    tooltipSubmitGrowthAward: 'Cliquez pour soumettre la demande de prix de croissance.',
    tooltipRetrySave: "Réessayer l'enregistrement",
    tooltipSaveFailed: "Échec de l'enregistrement",
  },
  contact: {
    confirmationModal: {
      header: 'Supprimer le contact',
      confirmationMessage:
        'Êtes-vous sûr de vouloir supprimer ce contact ? Cette action est irréversible.',
      confirmationButtonText: 'Supprimer le contact',
      successMessage: 'Contact supprimé avec succès !',
    },
    buttonAdd: 'Ajouter un nouveau contact',
    buttonChange: 'Modifier le contact',
    buttonCreate: 'Sélectionner ou créer un nouveau contact',
    buttonSave: 'Enregistrer le contact',
    buttonUpdate: 'Mettre à jour le contact',
    createContact: 'Créer un nouveau contact',
    editContact: 'Modifier le contact',
    editWarning: (appYear: string) =>
      `Vous êtes sur le point de modifier les détails d'un contact existant. Ces modifications seront mises à jour partout où ce contact est utilisé dans les applications ${appYear}.`,
    invalidEmail: 'Veuillez entrer une adresse e-mail valide.',
    invalidZipCode: 'Veuillez entrer un code postal valide.',
    invalidPhoneNumber: 'Numéro de téléphone invalide',
    requiredFieldSuffix: 'requis',
    labelCity: 'Ville',
    labelCountry: 'Pays',
    labelEmail: 'Adresse e-mail',
    labelFirstName: 'Prénom',
    labelLastNameLabel: 'Nom',
    labelName: 'Nom',
    labelPhoneNumber: 'Numéro de téléphone professionnel',
    labelStreetAddress2Label: 'Adresse (ligne 2)',
    labelStreetAddressLabel: 'Adresse (ligne 1)',
    labelTitle: 'Titre professionnel',
    labelWhatsApp: 'WhatsApp ou autre numéro de téléphone portable',
    labelZipCode: 'Code Postal',
    messageContactSaveFailed: 'Impossible d’enregistrer le contact.',
    messageContactRemoved: 'Contact supprimé!',
    messageMaximum: 'Vous avez atteint le nombre maximum de contacts pour cette section.',
    messageSaved: 'Contact enregistré !',
    placeHolderPhoneNumber: 'Numéro de téléphone professionnel',
  },
  dashboard: {
    accessToolkit: 'Accéder à la boîte à outils',
    accessToolkitPendingApproval: 'Disponible une fois votre demande approuvée',
    download: 'Télécharger',
    downloadTooltip: 'Télécharger et imprimer la demande',
    fieldApplication: 'Demande',
    fieldApplicationCycle: 'Cycle de candidature',
    fieldStatus: 'Statut',
    fieldSubmittedBy: 'Proposé par',
    growthAwardCardHeader: 'POSTULER AU PRIX DE CROISSANCE',
    growthAwardCardPendingLabel: (programName: string) =>
      `La candidature au prix de croissance peut commencer une fois votre candidature ${programName} soumise.`,
    growthAwardCardStartButton: 'Commencer le prix de croissance',
    labelApplication: 'DEMANDE',
    labelCreateApplication: 'Créer une nouvelle demande',
    labelPastApplications: 'Candidatures',
    messageCreateApplication: 'Création une nouvelle demande ...',
    messageNoApplications: 'Aucune candidature',
    portalClosedInformation: (latestAppCycleYear: string, nextOpenDate?: string | null) =>
      `La candidature pour le cycle ${
        latestAppCycleYear != null ? latestAppCycleYear + ' ' : ''
      }est actuellement fermée. ${
        nextOpenDate != null ? `Les candidatures ouvriront le ${nextOpenDate}. ` : ''
      }Merci.`,
    selectPartner: 'Sélectionner un partenaire',
    stateQuestionsCardHeader: 'VOTRE ETAT DEMANDE DES INFORMATIONS SUPPLEMENTAIRES',
    stateQuestionsCardPendingLabel:
      'Les questions spécifiques a l etat peuvent commencer une fois une candidature Tree City USA soumise.',
    stateQuestionsCardStartButton: 'Commencer les questions d état',
    viewApplication: 'Voir la demande',
    viewApplicationHelperTextDisabled: 'Demande non disponible',
    viewApplicationHelperTextEnabled: 'Voir la demande',
    viewApplicationButton: 'Voir',
    growthAwardHeader: 'Prix de croissance',
    growthAwardPendingLabel: 'Prix de croissance en attente',
    growthAwardStartButton: 'Commencer',
    stateQuestionsHeader: 'Questions d’état',
    stateQuestionsPendingLabel: 'Questions d’état en attente',
    stateQuestionsStartButton: 'Commencer',
    messageCreateApplicationError: 'Erreur lors de la création de la demande.',
    messageNoCycleFound: 'Aucun cycle de candidature trouvé.',
    messageFetchApplicationsError:
      'Impossible de charger les candidatures. Veuillez réessayer ou actualiser la page.',
    exportEmailLabel: 'Entrez votre adresse e-mail pour recevoir un lien de téléchargement',
    exportEmailAlreadyAdded: (email: string) =>
      `'${email}' a déjà été ajouté à la liste des destinataires de l'export.`,
    exportEmailPlaceholder: 'Adresse e-mail',
    exportSelectApplicationType: 'Sélectionnez le type de données à exporter',
    exportSelectState: 'Sélectionnez l’état',
    exportSelectCounty: 'Sélectionnez le comté',
    exportSelectPartner: 'Sélectionnez le partenaire',
    exportSelectProgram: 'Sélectionnez le programme',
    exportIncludeQuestionResponses: 'Inclure les réponses aux questions de la demande',
    exportInvalidEmailAddress: (email: string) => `'${email}' n'est pas une adresse e-mail valide.`,
    exportGenerating: 'Génération du lien de téléchargement...',
    exportSuccessMessage: 'Un lien de téléchargement a été envoyé à votre adresse e-mail.',
    exportErrorMessage: 'Erreur lors de la génération du lien de téléchargement.',
    exportTypeMainApplications: 'Données principales de la demande',
    exportTypeGrowthAward: 'Données du prix de croissance',
    exportTypeStateQuestions: 'Données des questions d’état',
    loadingText: 'Chargement du tableau de bord...',
    exportGenerateCsv: 'Générer le CSV',
    exportMaxEmailsWarning:
      'Vous avez atteint le nombre maximum d’e-mails pour aujourd’hui. Veuillez réessayer demain.',
    exportModalTitle: 'Exporter les données du tableau de bord',
    exportRequiredParams: 'Veuillez sélectionner au moins un paramètre pour l’exportation.',
    exportOptionalParams: 'Paramètres optionnels',
  },
  dataUpload: {
    confirmationModal: {
      header: 'Supprimer la pièce jointe',
      confirmationMessage:
        'Êtes-vous sûr de vouloir supprimer cette pièce jointe ? Cette action est irréversible.',
      confirmationButtonText: 'Supprimer la pièce jointe',
      successMessage: 'Pièce jointe supprimée avec succès !',
    },
    errorURL: 'Veuillez soumettre une URL valide',
    helperSelectFile:
      "Cliquez sur Sélectionner pour rechercher et choisir un fichier sur votre ordinateur. Cliquez sur Enregistrer pour le joindre à votre demande. Veuillez vous assurer que votre nom de fichier est unique. Formats d'archives compressés, par ex. .zip, ne sont pas pris en charge.",
    helperUrl:
      "Si vous partagez une URL, assurez-vous qu’il s’agit d’une page Web publique et non d’un lien vers une plateforme de partage de documents (p. ex. Google Docs ou Dropbox). S'il s'agit d'une URL, assurez-vous d'inclure http:// ou https:// dans le cadre de l'URL. Cliquez sur Enregistrer pour le joindre à votre demande.",
    labelAddFile: 'Ajouter le fichier',
    labelEventProof: 'Joindre une preuve de',
    labelFile: 'Fichier',
    labelURL: 'URL',
    labelSave: 'Enregistrer',
    labelSaving: 'Enregistrement',
    labelSelectFile: 'sélectionner',
    labelUpload: 'Téléchargement',
    messageDownload: 'Cliquez pour télécharger le PDF',
    messageFailed: 'Échec du téléchargement.',
    messageSuccess: 'Téléchargement réussi !',
    placeholderURL: 'Tapez une URL',
    errorFileSize: 'La taille du fichier dépasse la limite de 25 Mo.',
    errorFileTypeUnsupported:
      "Ce type de fichier n'est pas pris en charge. Veuillez téléverser un fichier autre que .zip.",
    warningDuplicateFileSkipped:
      'Nom de fichier en double détecté. Les fichiers en double ont été ignorés.',
    warningDuplicateUrlExists: 'Cette URL a déjà été ajoutée.',
    labelTryAgain: 'Réessayer',
    labelUploadedFile: 'Fichier téléversé',
    labelSavedUrl: 'URL enregistrée',
    labelGetPdfSummary: 'Obtenir le résumé PDF',
    tooltipClearError: "Effacer l'erreur",
    tooltipOpen: 'Ouvrir',
    tooltipDownload: 'Télécharger',
    tooltipDelete: 'Supprimer',
    ariaClearUploadError: "Effacer l'erreur de téléversement",
    ariaOpenAttachment: 'Ouvrir la pièce jointe',
    ariaOpenUrlAttachment: "Ouvrir l'URL jointe",
    ariaDownloadAttachment: 'Télécharger la pièce jointe',
  },
  deadlineBanner: {
    deadlineText: 'LA DATE LIMITE DE LA DEMANDE',
    stateReviewDeadlineText: "Date limite de revision de l'Etat",
  },
  decimalQuestion: {
    maxValueExceeded: `Votre saisie doit être un nombre entre 0 et ${formatNumberDisplayValue(
      maxDecimalValue.toString(),
      'decimal'
    )}.`,
  },
  event: {
    confirmationModal: {
      header: 'Supprimer le contact',
      confirmationMessage:
        'Êtes-vous sûr de vouloir supprimer ce contact ? Cette action est irréversible.',
      confirmationButtonText: 'Supprimer le contact',
      successMessage: 'Événement supprimé avec succès !',
    },
    buttonAddEvent: 'Ajouter',
    celebration: 'Fête',
    dateRangeError: 'Veuillez sélectionner une date entre le {{minDate}} et le {{maxDate}}.',
    eventName: "Nom de l'événement",
    helperEvent:
      "Pour ajouter un autre événement, cliquez sur le bouton Ajouter ci-dessous. Pour supprimer un événement supplémentaire, cliquez sur le bouton supprimer sur l'événement (vous devez avoir au moins un événement).",
    labelName: 'Quand votre événement communautaire a-t-il été célébré ?',
    labelSubType: 'Type d’événement',
    labelSubTypeOther: 'Précisez le type d’événement pour « Autre ».',
    messageDelete: 'Suppression...',
    messageSaved: 'événement enregistré !',
    other: 'Autre',
    summary: 'Résumer la',
    tooltipDelete: 'Cliquez pour supprimer cet événement.',
    treeDay: "Jour de l'arbre",
    type: 'Type',
  },
  header: {
    application: 'DEMANDE',
    dashboard: 'TABLEAU DE BORD',
    error: 'Erreur',
    inactive: 'Utilisateur inactif',
    myaccount: 'Informations du compte',
    mycontact: 'Informations de contact',
    pending: 'EN ATTENTE',
    pendingMessage:
      "Votre compte est en attente de validation. Vous pourrez continuer une fois qu'un administrateur aura approuvé votre demande.",
    signedInAs: 'Connecté en tant que',
    signup: "S'INSCRIRE",
    tooltipDashboard: 'Retour au tableau de bord',
    tooltipLanguage: 'Changer de langue',
    tooltipHelp: 'Aide',
    tooltipMyAccount: 'Mon compte',
    tooltipSignOut: 'Se déconnecter',
    tooltipUserManagement: 'Gestion des utilisateurs',
    usermanagement: 'GESTION DES UTILISATEURS',
    instructionsTitle: 'Instructions',
    tooltipStopImpersonation: 'Arrêter l’usurpation d’identité',
    growthaward: 'PRIX DE CROISSANCE',
    statequestions: 'QUESTIONS D’ÉTAT',
  },
  integerQuestion: {
    invalidInteger: 'Votre saisie doit être comprise entre 0 et 99 999 999.',
    labelSum:
      "La somme des gaules et des semis doit être inférieure ou égale au nombre total d'arbres plantés.",
  },
  multiCheckbox3: {
    helperMaximum: 'Pas plus de 3 choix',
  },
  multiCheckbox: {
    helper: 'Veuillez sélectionner au moins un',
  },
  myaccount: {
    accountSettings: 'Paramètres du compte',
    characterlimit: (charLimit: number) => `Limite de ${charLimit} caractères`,
    errorHelperText: 'Veuillez remplir tous les champs obligatoires',
    emailNewAccountHelperText:
      'Pour enregistrer une nouvelle adresse e-mail, vous devrez créer un nouveau compte.',
    partnerDetails: (partnerName: string) => `Détails de ${partnerName}`,
    preferredlanguage: 'Quelle est votre langue préférée ?',
    primaryContactHeader: 'Informations du contact principal',
    myAccount: 'Mon compte',
    titlerequired: 'Titre requis',
    updatePrimaryContactError: 'Erreur lors de la mise à jour du contact principal',
    updatePrimaryContactSuccess: 'Contact principal mis à jour',
    updateUserContactSuccess: 'Contact utilisateur mis à jour',
    updateUserContactError: 'Erreur lors de la mise à jour du contact utilisateur',
    unsavedChangesBody:
      'Vous avez des modifications non enregistrées. Voulez-vous les abandonner et naviguer ailleurs ?',
    unsavedChangesTitle: 'Modifications non enregistrées',
    buttonKeepEditing: 'Continuer à modifier',
    buttonDiscardChanges: 'Abandonner les modifications',
    shippingContactHeader: 'Informations du contact de livraison',
    tabAccountSettings: 'Paramètres du compte',
    tabPrimaryContact: 'Contact principal',
    tabShippingAddress: 'Adresse de livraison',
    errorUpdatingShippingContact: 'Erreur lors de la mise à jour du contact de livraison',
    shippingContactUpdated: 'Contact de livraison mis à jour',
  },
  partner: {
    other: 'Autre',
  },
  partnerUpdateModal: {
    saveAwards: 'Enregistrer les prix',
    saveContacts: 'Enregistrer les contacts',
    savePartnerInfo: 'Enregistrer les informations du partenaire',
    tabContacts: 'Contacts',
    tabPartnerInfo: 'Informations du partenaire',
    tabYearsAwarded: 'Années récompensées',
    titleEditPartnerDetails: 'Modifier les informations du partenaire',
    tooltipError: 'Erreur',
    tooltipHasUnsavedChanges: 'Modifications non enregistrées',
    tooltipSaved: 'Enregistré',
    tooltipSaving: 'Enregistrement',
  },
  profileMenu: {
    addAccount: 'Ajouter un compte',
    addAccountTooltip:
      'Ceci s’adresse aux organisations qui participent à plusieurs programmes ou qui ont plusieurs emplacements et qui doivent créer des comptes distincts pour chacun.',
    manageAccount: 'Gérer le compte',
    myAccount: 'Mon compte',
    signOut: 'Se déconnecter',
    admin: 'Administration',
    userManagement: 'Gestion des utilisateurs',
  },
  percentQuestion: {
    invalidPercent: 'Votre saisie doit être un nombre entre 0 et 100.',
  },
  signature: {
    buttonClear: 'Effacer',
    messageSaved: 'Signature enregistrée!',
    terms: 'Termes et conditions',
    tooShortError: 'La signature est trop courte. Veuillez dessiner une signature plus longue.',
  },
  submitConfirmation: {
    title: 'Candidature soumise',
    message: 'Merci ! Votre candidature a été soumise et est maintenant en attente de révision.',
    reviewApplication: 'Revoir la candidature',
    backToDashboard: 'Retour au tableau de bord',
  },
  signup: {
    buttonSubmit: 'ENVOYER',
    checkContactShipping: "Identique à l'adresse du contact principal",
    checkIncludeInDirectory:
      'SI MA DEMANDE EST APPROUVÉE, JE NE SOUHAITE PAS QUE MON NOM ET MON ADRESSE E-MAIL SOIENT INCLUS SUR LA PAGE D’ANNUAIRE DU CENTRE DE RESSOURCES DES MEMBRES DE TREE CITIES OF THE WORLD (UNIQUEMENT ACCESSIBLE PAR LES AUTRES « TREE CITIES » RECONNUES).',
    choiceNo: 'Non',
    choiceSelect: 'Sélectionner',
    choiceYes: 'Oui',
    countrySelect: 'Sélectionner votre Pays',
    fuzzyMatchContinue: (partnerTerm: string) => `Continuer à créer un nouveau ${partnerTerm}`,
    fuzzyMatchMessage:
      'Nous avons trouvé des partenaires existants portant des noms similaires dans votre état. Vouliez-vous dire l’un d’entre eux ?',
    fuzzyMatchSelect: 'Sélectionner',
    fuzzyMatchTitle: 'Partenaires similaires trouvés',
    errorMessageEnd: 'Vérifiez les valeurs et ressaisissez-les si nécessaire.',
    errorMessageStart:
      "Il y a eu un problème avec votre formulaire. Les questions suivantes n'ont pas de valeur valide :",
    errorPartnerHeader: 'Détails du Ville',
    errorPrimaryContactHeader: 'Détails du contact principal',
    errorShippingContactHeader: 'Détails du contact de livraison',
    headerExistingPartnerDetails: 'Sélectionnez votre ville',
    headerAddAccount: 'Ajouter un compte',
    headerLabel: 'Information',
    headerPartnerDetails: 'Details de la ville',
    headerPrimaryContact: 'Informations du contact principal',
    headerProgram: 'Portail de reconnaissance des programmes',
    headerSelectProgram: 'Pour quoi postulez-vous ?',
    headerShipping: 'Adresse de livraison par défaut',
    headerSocialMedia: 'Canaux de médias sociaux pour votre ',
    helperCityError: 'Ville requis',
    helperEmailError: 'Courriel requis',
    helperNameError: 'Nom requis',
    helperShippingCityError: 'Ville requis',
    helperShippingStreetAddressError: 'Adresse requis',
    helperShippingZipCodeError: 'Veuillez entrer un code postal valide',
    helperStreetAddressError: 'Adresse requis',
    helperZipCode: 'Veuillez entrer des valeurs numériques',
    helperZipCodeError: 'Code Postal requis',
    labelAppliedToADF: (partnerTerm: string, programName: string) =>
      `Vous n'avez pas trouvé votre ${partnerTerm} ou c'est la première fois que votre ${partnerTerm} postule à la reconnaissance ${programName}. Cliquez pour créer une nouvelle ${partnerTerm}.`,
    labelCategory: 'Quelle catégorie décrit le mieux votre ',
    labelCity: 'Ville',
    labelGenericEmail:
      'Adresse électronique générique de la mairie (Exemple: forester@cityname.com)',
    labelName: 'Nom',
    labelPhoneNumber: 'Numéro de téléphone de la ',
    labelShippingCity: 'Ville',
    labelShippingCountry: 'Pays',
    labelShippingStreetAddress: 'Adresse (ligne 1)',
    labelShippingStreetAddress2: 'Adresse (ligne 2)',
    labelShippingZipCode: 'Code Postal',
    labelSubCategoryOther: 'Veuillez préciser:',
    labelTitle: 'Titre professionnel',
    labelZipCode: 'Code Postal',
    messageSubmissionError: "Erreur lors de la soumission du formulaire d'admission.",
    messageSubmissionSuccess: "Formulaire d'admission soumis avec succès.",
    partnerNotFoundHelperText: (partnerTerm: string) =>
      `Aucun ${partnerTerm} trouvé - Cochez la case ci-dessous pour créer un nouveau ${partnerTerm}`,
    partnerSelect: 'Sélectionner votre ',
    required: 'numéro requis',
    selectProgram: 'Sélectionnez le programme',
    subHeaderExistingPartnerDetails: (partnerTerm: string, programName: string) =>
      `Si votre ${partnerTerm} a déjà déposé une demande de reconnaissance pour la reconnaissance ${programName}, veuillez rechercher votre ${partnerTerm} à l'aide de ce formulaire. S'il n'est pas trouvé, cochez la case ci-dessous pour créer une nouvelle ${partnerTerm}.`,
    subHeaderPartnerDetails:
      "Remarque : si vous postulez pour plusieurs emplacements, veuillez remplir le formulaire ci-dessous pour un seul emplacement. Vous aurez la possibilité d'ajouter des emplacements supplémentaires plus tard dans le processus.",
    tooltipSubmit: "Cliquez pour soumettre le formulaire d'admission.",
  },
  userLoadError: {
    contactUs: 'Nous contacter',
    message:
      'Veuillez réessayer. Si le problème persiste, contactez-nous en indiquant la référence ci-dessous.',
    referenceLabel: 'Référence',
    signOut: 'Se déconnecter',
    title: "Nous n'avons pas pu charger votre compte.",
    tryAgain: 'Réessayer',
  },
  userManagement: {
    removeReviewerAssignmentConfirmationModal: {
      header: "Supprimer l'affectation du réviseur",
      confirmationMessage:
        'Êtes-vous sûr de vouloir supprimer cette affectation de réviseur ? Cette action est irréversible.',
      confirmationButtonText: "Supprimer l'affectation",
      successMessage: 'Affectation du réviseur supprimée avec succès !',
    },
    snackbarError: 'la modification a échoué',
    snackbarSuccess: 'mis à jour avec succès',
  },
};
